import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setFundChartStartDate } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/start-date/start-date.actions';
export const startDate = createReducer(null, on(setChartData, (state, { chartData }) => chartData.params.startDate), on(setFundChartStartDate, (state, { date }) => date));
